import * as React from 'react';
import { useContext } from 'react';
import styled from 'styled-components';

import WidgetDetailsContext from 'report/report-creation/WidgetDetailsContext';

import ReportParameters from './ReportParameters';
import WidgetsList from './WidgetsList';
import AddWidget from './AddWidget';

const Header = styled.h3`
  margin-bottom: 15px;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-items: center;
  justify-content: space-between;
`;

type Props = {
  editAllowed: boolean;
  scopeLocked?: boolean;
};

const Content = ({ editAllowed, scopeLocked = false }: Props) => {
  const { searchIds, parameters } = useContext(WidgetDetailsContext);
  // Reports under a scope-locked entity scope (e.g. Illuminate) lock widgets and positions.
  // Parameter values remain user-editable.
  const widgetsLocked = !editAllowed || scopeLocked;

  return (
    <>
      {Object.keys(parameters).length > 0 ? (
        <>
          <HeaderContainer>
            <Header>Required Parameters</Header>
          </HeaderContainer>
          <ReportParameters parameters={parameters} parameterSearchIds={searchIds} />
        </>
      ) : null}
      <HeaderContainer>
        <Header>Widgets</Header>
        <AddWidget disabled={widgetsLocked} />
      </HeaderContainer>
      <WidgetsList disabled={widgetsLocked} />
    </>
  );
};

export default Content;
